import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { Box } from "@mui/system";
import { InputField, SelectField } from "../../../../utils/FormFields";
import ResultsDocuments from "./ResultsDocuments";
import { Tests, TestsApi } from "../../../../api/medical-operations";
import BasicDateTimePicker from "../../../../utils/FormFields/BasicDateTimePicker";
import { useRecoilValue } from "recoil";
import { configState } from "../../../../recoil/atoms";
import { toast } from "react-toastify";

const PatientTest = () => {
  const config = useRecoilValue(configState);
  const [tests, setTests] = useState<Tests[]>([]);

  const getTests = () => {
    const Tests = new TestsApi(config);
    Tests.getTests()
      .then((res) => {
        setTests(res?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };
  useEffect(() => {
    getTests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const availableTests = tests?.map((test: Tests) => {
    return {
      label: test.Name,
      value: test.TestID,
    };
  });

  return (
    <>
      <Box
        sx={{
          py: 4.5,
          bgcolor: "#e7e3ff",
          color: "grey.800",
          borderRadius: "16px",
        }}
      >
        <Grid
          container
          rowSpacing={6}
          spacing={2}
          sx={{ p: 1, pt: 2, justifyContent: "center", alignContent: "center" }}
        >
          <Grid item xs={12} sm={7} sx={{ mb: -3 }}>
            <SelectField name="TestID" label="Test" data={availableTests} fullWidth />
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mb: -3 }}>
            <BasicDateTimePicker label="Release Date" name="ReleaseDate" />
          </Grid>
          <Grid container />

          <Grid item xs={12} sm={10}>
            <ResultsDocuments />
          </Grid>
          <Grid container />
          <Grid item xs={12} sm={10}>
            <InputField name={`ResultOutcomes`} label="Result Outcomes" multiline rows={4} fullWidth variant="filled" />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default PatientTest;
